import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { ReactComponent as CopyIcon } from 'assets/img/icons/copy-clipboard.svg';
import { If } from 'utils';

export default function ExternalLink({
  href = '',
  text = '',
  fallback = null,
  allowCopy = false,
  className = '',
  containerClassName = '',
  copyButtonClassName = ''
}) {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => {
        setIsCopied(false);
        clearTimeout(timer);
      }, 600);
    }
  }, [isCopied]);

  const onCopy = () => {
    if (isCopied) return;
    navigator.clipboard.writeText(href);
    setIsCopied(true);
  };

  if (!href) return fallback;

  return (
    <div className={cn(styles.container, containerClassName)}>
      <If test={allowCopy}>
        <UiKit.Tooltip>
          <UiKit.Tooltip.Trigger>
            <UiKit.Button
              size="sm"
              variant="outline"
              onClick={onCopy}
              className={cn('p-0', copyButtonClassName)}
            >
              <CopyIcon />
            </UiKit.Button>
          </UiKit.Tooltip.Trigger>
          <UiKit.Tooltip.Content>
            {isCopied ? 'Copied ✅' : 'Copy Link'}
          </UiKit.Tooltip.Content>
        </UiKit.Tooltip>
      </If>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(styles.link, 'truncate', className)}
      >
        {text}
      </a>
    </div>
  );
}
